import styled from 'styled-components';
export const Large = styled.span `
  ${({ theme: { overviewPriceLarge } }) => overviewPriceLarge}
`;
export const Small = styled.span `
  ${({ theme: { overviewPriceSmall } }) => overviewPriceSmall}
`;
export const Inner = styled.span `
  display: flex;
  flex-direction: column;
`;
export const Wrapper = styled.span `
  display: flex;
  align-items: center;

  ${({ theme: { overviewPriceWrapper } }) => overviewPriceWrapper}
`;
export default {
    Large,
    Small,
    Inner,
    Wrapper,
};
